import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { HelpTooltip } from '../../../../components/PriceOverviewCard/components/Rooms/components/HelpTooltip.js';
import { Title } from '../../../../components/PriceOverviewCard/components/Rooms/components/Title.js';
import { DEFAULT_LOCALE } from '../../../../components/PriceOverviewCard/models.js';
import { Divider, Flex, LabelMedium, LabelMediumSemiBold, LabelXSmall } from '../../../../primitives/index.js';
import { priceFormatter, qaId } from '../../../../utils/index.js';
import { PRICE_OVERVIEW_QA_ID } from '../../../../utils/qaId.js';
export const Rooms = ({
  items,
  locale = DEFAULT_LOCALE,
  children
}) => {
  const {
    t
  } = useTranslation('priceOverviewCard');
  return _jsxs(Flex, {
    gap: "12px",
    children: [items?.map((room, index) => _jsxs(Flex, {
      gap: "4px",
      "data-testid": qaId(PRICE_OVERVIEW_QA_ID, 'room-information-section'),
      children: [_jsxs(Flex, {
        direction: "row",
        justifyContent: "space-between",
        children: [_jsxs(Title, {
          gap: "2px",
          direction: "row",
          bold: room.totalPrice.displayPrice.currency !== room.totalPrice.price.currency,
          children: [t('room', {
            index: index + 1
          }), ": ", room.type, _jsx(HelpTooltip, {
            room: room,
            index: index
          })]
        }), _jsxs(Flex, {
          gap: "global/small",
          alignItems: "end",
          children: [room.totalPrice.displayPrice.currency === room.totalPrice.price.currency ? _jsx(LabelMedium, {
            children: priceFormatter(locale, room.totalPrice.displayPrice.currency).format(room.totalPrice.displayPrice.value)
          }) : _jsxs(LabelMediumSemiBold, {
            children: [priceFormatter(locale, room.totalPrice.displayPrice.currency).format(room.totalPrice.displayPrice.value), "*"]
          }), room.totalPrice.displayPrice.currency !== room.totalPrice.price.currency && _jsx(LabelXSmall, {
            color: "contentSecondary",
            children: priceFormatter(DEFAULT_LOCALE, room.totalPrice.price.currency).format(room.totalPrice.price.value)
          })]
        })]
      }), room.travelers.map(({
        name,
        price,
        displayPrice
      }, index) => _jsxs(Flex, {
        direction: "row",
        justifyContent: "space-between",
        children: [displayPrice.currency === price.currency ? _jsx(LabelXSmall, {
          color: "contentSecondary",
          children: name
        }) : _jsx(LabelMedium, {
          children: name
        }), _jsxs(Flex, {
          gap: "global/small",
          alignItems: "end",
          children: [displayPrice.currency === price.currency ? _jsx(LabelXSmall, {
            color: "contentSecondary",
            children: priceFormatter(locale, displayPrice.currency).format(displayPrice.value)
          }) : _jsxs(LabelMedium, {
            children: [priceFormatter(locale, displayPrice.currency).format(displayPrice.value), "*"]
          }), displayPrice.currency !== price.currency && _jsx(LabelXSmall, {
            color: "contentSecondary",
            children: priceFormatter(DEFAULT_LOCALE, price.currency).format(price.value)
          })]
        })]
      }, index))]
    }, index)), children, _jsx(Divider, {
      type: "dotted",
      category: "primary"
    })]
  });
};